
import { Component, Vue } from 'vue-property-decorator';

import { Action } from '@/store';
import { TypedObject } from '@/definitions';

import template from './navbar.vue';

@Component({
  mixins: [template],
})
export default class Navbar extends Vue {
  dropdownActive: boolean = false;
  menuOpened: boolean = false;

  mounted() {
    const elements = document.getElementsByClassName('navbar-item');
    for (var i = 0; i < elements.length; i++) {
      var anchor = elements[i] as HTMLElement;
      anchor.onclick = () => {
        this.menuOpened = false;
      }
    }
  }

  get userName(): string {
    return this.$Store.getters.USERNAME as string;
  }

  get info(): TypedObject {
    return {
      version: this.$package.version,
      title: this.$package.title,
    };
  }

  get company(): string {
    return this.$Store.state.user.company;
  }

  get admin(): boolean {
    return this.$Store.state.user.isAdmin;
  }

  get appAdmin(): boolean {
    return this.$Store.state.user.isAppAdmin;
  }

  get hasStats(): boolean {
    return this.$Store.state.user.hasStats;
  }

  toggleOpen(): void {
    this.menuOpened = !this.menuOpened;
  }

  isActiveRoute(path: string): boolean {
    return this.$route.path === path;
  }

  logoutUser(): void {
    this.$Store.dispatch(Action.LOGOUT_USER);
    this.$router.push({ path: '/login' });
  }
}